function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrzelewy24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 2400,
    height: 840,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4095.87 2870.98 1564.62 2.14-57.2-356.01L4295 1267.97l1097.73 2.19-63.77-384.5-1616.71-.269 67.56 396.519 1254.11 1201.01-1000.47.05 62.42 388.01M2056.55 2993.99c-.41-4.56-37.77-225.98-88.27-487.86-19.32-100.22-95.86-154.02-184.18-172.68-145.78-30.79-302.68-25.14-302.68-25.14l-690.24 1.76 151.55 914.76 625.44-1.73s42.32.88 101.43-.04c67.17-1.04 156.01-4.41 229.03-14.03 62.53-8.23 113.45-21.05 129.2-40.93 20.78-26.23 29.36-59.71 32.24-90.31 4.11-43.5-3.3-81.16-3.52-83.8zm328.87 485.88c-34.29 36.2-82.67 64.12-137.34 85.66-56.69 22.33-120.15 37.8-181.66 48.5-78.37 13.64-153.59 19.54-207.68 22.07-49.76 2.33-81.64 1.8-81.64 1.8l-683.94.09-508.965.07L126.746 885.5l425.91-.441L721.008 1905.37l825.772-3.57s321.52-12.62 549.81 108.14c228.25 120.86 288.69 395.63 288.69 395.63s25.11 101.94 45.61 226.42c22.53 136.69 45.6 300.83 57.58 388.22 5.25 38.35 8.37 61.93 8.37 61.93s5.54 28.34 6.06 72.28c.73 61.47-8.36 153.48-56.21 241.14-15.84 29-35.91 57.53-61.27 84.31M7780.92 3638.5l409.64.33-458.99-2753.939-410.68.66L7780.92 3638.5M9969.47 2871.42l392.93.33 138.8-1397.29 604.4 1399.82 485-1.32 143.3-1404.26 604.5 1402.94 407.6.38-866.3-1985.43-484-.051-139.5 1390.271-611.5-1390.298-475.8-1.34-199.43 1986.248",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6934.91 2130.8-915.01.99 36.4 145.24s31.77 113.56 95.23 162.08c63.5 48.47 144.63 56.7 221.03 64.11 76.47 7.44 278.79 21.69 443.95-12.35 54.84-11.25 106.98-42.09 120.54-87.76 32.05-107.81-2.14-272.31-2.14-272.31zm88.97 723.88c-114.82 37.44-314.24 44.85-482.53 42.76-163.13-2.03-237.94-9.66-298.81-22.78 0 0-290.21-41.6-454.87-245.63-164.67-204.02-213.8-650.49-213.8-650.49s-97.76-493.38-69.16-657.77c28.54-164.39 79.81-316.77 266.11-388.29 186.34-71.519 344.37-68.332 344.37-68.332s332.03-26.078 582.21 33.102c250.19 59.051 382.09 235.19 382.09 235.19s58.67 75.75 101 166.24c42.37 90.48 54.77 153.28 56.64 161.01l26.24 106.6-425.34-.55s-23.44-280.7-252.77-306.61c-229.27-25.85-352.33-16.08-396.68-14.41-43.7 1.6-290.04-8.55-270.08 196.84.11 2.77.29 6.83.57 12.59 11.42 234.27 37.43 294.98 37.43 294.98l1335.19 3.76 56.97 329.77c64.83 375.17 17.24 660.49-324.78 772.02",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5919.57 1450.89c-.42-3.16-.77-6.27-1.07-9.33-.59-15.63 1.2 10.19 1.07 9.33M8438.22 1450.42c-.42-3.16-.77-6.27-1.07-9.33-.59-15.62 1.21 10.21 1.07 9.33",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9449.99 2131.35-914.95.93 36.39 145.3s31.79 113.59 95.24 162.03c63.45 48.46 144.57 56.76 221.04 64.16 76.46 7.36 278.73 21.68 443.94-12.4 54.78-11.22 106.93-42.05 120.54-87.77 32.06-107.8-2.2-272.25-2.2-272.25zm92.6 722.89c-114.88 37.44-314.29 44.85-482.59 42.73-163.13-2-237.94-9.63-298.81-22.75 0 0-290.21-41.66-454.87-245.63-164.67-204.08-213.8-650.49-213.8-650.49s-97.75-493.43-69.15-657.83c28.59-164.39 79.8-316.68 266.15-388.282 186.3-71.519 344.33-68.34 344.33-68.34s332.07-26.019 582.21 33.102c250.18 59.109 382.08 235.25 382.08 235.25s58.68 75.76 101 166.21c42.37 90.46 54.77 153.31 56.7 161.05l26.23 106.59-425.39-.55s-23.44-280.73-252.76-306.58c-229.28-25.88-352.34-16.17-396.64-14.52-43.69 1.62-290.08-8.5-270.13 196.89.11 2.77.29 6.84.57 12.62 11.42 234.27 37.44 294.98 37.44 294.98l1335.18 3.73 56.98 329.75c64.88 375.17 17.23 660.48-324.73 772.07",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13218.5 2871.23 262.7-1451.55 743.5 1453.06 418.2-3.57-1071.2-2075.451s-193.8-375.547-314.1-470.84c-120.2-95.387-193.6-138.039-292-147.758-98.3-9.769-137.8-16.629-232.1 0l-99.7 17.508 62.4 370.582s165.6-31.152 264.2 7.769c98.6 39 178.4 206.989 178.4 206.989l49.7 84.031-387.1 2009.8 417.1-.57",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14249.4 2575.55 415.4-.57 24.6 161.09s44.4 290.62 143.3 346.77c31.7 17.98 82.6 35.1 141.3 45.32 108.5 18.81 247 21 359 16.96 172.8-6.23 237.5-7.76 413.2-27.73 175.7-20.01 130.9-189.62 130.9-189.62l-34.4-252.93s-15-113.3-55.5-184.09c-35.9-62.6-133.7-104.69-190.3-123.19-136.8-44.62-604.8-163.58-604.8-163.58l-368.4-106.19s-225.9-65.52-352.9-205.63c-126.9-140.16-176.8-299.53-194.2-382.76-17.3-83.16-114.5-656.053-114.5-656.053l1986-.851 66.3 397.054-1570.9-1.8 28.3 161.78s18.2 166.81 85.8 221.21c21.2 17.24 31.8 40.02 157.2 84.73 74.9 26.7 331.2 94.95 331.2 94.95l592.7 161.67s323.3 83.27 450.7 259.65c127.4 176.32 176.4 514.37 176.4 514.37s34.2 328.16 8.1 431.05c-26 102.88-123.4 226.44-241.5 279.1-118.1 52.66-241.8 83.48-599.5 78.59-357.6-4.94-534.2-21.64-715.2-88.21-181-66.51-285.7-187.95-352.2-359.09-73.5-161.63-116.1-512-116.1-512",
    style: {
      fill: "#b1afad",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15596 1630.06-770.4 1.17 937.7 998.91-167.3-1000.08zm364 .28 246.8 1479.84-437.2.27-1362.4-1463.2-61.9-370.52 1191.5.13-87.2-519.927 365.5-.467 86.3 520.344 337.6-.7 61 354.7-340-.47",
    style: {
      fill: "#b1afad",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.15 0 0 -.15 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3289.27 3412.41H4602s294.48 237.95 503.17 390.54c208.69 152.62 588.58 393.61 588.58 393.61l-741.5 346.96s-626.62-388.12-892.67-571.24c-258.69-168.73-770.31-559.87-770.31-559.87M6111.35 4441.92l-608.95 409.97s551.15 313.03 1283.65 605.15c732.5 292.17 1123.14 413.7 1123.14 413.7l123.67-580.73s-705.22-235.8-1109.37-426.76c-417.38-178.01-812.14-421.33-812.14-421.33M8483.28 5417.47l-105.6 595.1s751.65 199.86 1440.4 328.03c688.72 128.17 1602.32 188.73 1602.32 188.73l-302.3-919.26s-803.5 109.67-1557.28 7.3c-587.71-69.98-1077.54-199.9-1077.54-199.9M11595 5532.46l508.5 1021.38s1113.2 21.62 2073-126.52c959.8-148.2 1837.8-376.49 1818.7-386.48l-2434.4-1273.16s-568.5 360.19-1274.9 581.18c-400.1 116.69-690.9 183.6-690.9 183.6",
    style: {
      fill: "#b1afad",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12053 3866.24 460.9-349.27H16300s-7.7 122.59-108.6 296.19c-63.1 108.8-177.4 223.8-297.2 343.34-43.6 43.43-218.2 179.51-348.5 264-334.3 216.64-521 300.41-867.7 458.4l-2625-1012.66",
    style: {
      fill: "#b1afad",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.15 0 0 -.15 0 840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3573.81 2873.12c-165.04 0-320.92-65.1-454.13-138.04l23.36 138.04h-437.35L2355.48 895.879h437.67l194.03 1095.411c40.42 222.29 205.83 496.67 530.43 496.67l226.26.91 68.06 384.25h-238.12",
    style: {
      fill: "#d32536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13 0 0 -.13 0 840)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrzelewy24);
export default __webpack_public_path__ + "static/media/przelewy24.cbc67715887e4c6648dc507ed1511714.svg";
export { ForwardRef as ReactComponent };